import { render } from "./ChartCriteriaRoadmap.vue?vue&type=template&id=2a52df7f"
import script from "./ChartCriteriaRoadmap.vue?vue&type=script&lang=js"
export * from "./ChartCriteriaRoadmap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__